const getColorSanity = (color) => {
    if (!color) return 'transparent';

    const { hex, rgb, alpha } = color;

    const opacity = alpha ?? rgb?.a ?? 1;

    if (opacity < 1 && rgb) {
        return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
    }

    if (hex) {
        return hex;
    }

    if (rgb) {
        return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
    }

    return 'transparent';
};

export default getColorSanity;